import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import Box from '@mui/material/Box'
import dynamic from "next/dynamic";
const ParseHtml = dynamic(() => import("@components/Custom/ParseHtml"));

const ProductPrimaryDescription = (props) => {
    const {product, template_page_settings} = props;   
    const {getPageSetting} = useGlobalSettings();
    const show_description_short = getPageSetting(template_page_settings, 'product', 'show_description_short', 'yes') == 'yes';

    return (
        <Box className='pt-2 default-grey' >
            { (product?.product_description_short != "") ? (
                    show_description_short ? <ParseHtml html={product?.product_description_short} /> : null
                ) : (
                    <ParseHtml html={product?.product_description_long} />    
                )
            }
        </Box>
    )
}

export default ProductPrimaryDescription